import Phaser from 'phaser';
import ScreenContainer from '../display/ui/ScreenContainer';
import Hud from 'app/ui/hud/Hud';

export default class extends Phaser.State {
  init() {}

  preload() {}

  create() {
    // store everything in a container, it will reposition for screen
    this.container = new ScreenContainer(this.game, { background: 'background_welcome' });
    this.game.add.existing(this.container);
    // create and add the hud
    this.hud = new Hud(this.game, Hud.WELCOME);
    this.game.add.existing(this.hud);

    // Overlay
    this.bgOverlay = this.game.add.image(0, 0, 'background_overlay');
    this.bgOverlay.anchor.set(0.5);
    this.bgOverlay.x = this.game.defaultWidth * 0.5;
    this.bgOverlay.y = this.game.defaultHeight * 0.5;
    this.container.add(this.bgOverlay);

    // logo can sit in the container, this will keep it centered
    let logo = this.game.make.sprite(0, 0, 'logo_welcome');
    logo.x = this.game.defaultWidth * 0.5 - logo.width * 0.5;
    logo.y = 20;
    this.container.add(logo);

    // so, here be an exception to the norm :)
    // the play button is techinally default, but it sits behind the characters
    // however, the hud needs to go over the characters otherwise the 'howtoplay' button will get hidden behind
    // so we need to create the play button here and add it to the container
    this.playButton = this.hud.createHudButtonFromId('play_game');
    this.playButton.onInputDown.add(this.handlePlayButton, this);
    this.playButton.x = this.game.defaultWidth * 0.5 - this.playButton.width * 0.5;
    this.playButton.y = this.game.defaultHeight * 0.5 - this.playButton.height * 0.5;
    this.container.add(this.playButton);

    // Add static images
    let gang = this.game.make.sprite(0, 0, 'gang_welcome');
    gang.x = this.game.defaultWidth * 0.5 - gang.width * 0.5;
    gang.y = this.game.defaultHeight - gang.height;
    this.container.add(gang);

    this.tvCTABanner = this.game.make.graphics();
    this.tvCTABanner.beginFill(0x09293b, 0.65);
    this.tvCTABanner.drawRect(0, 0, this.game.defaultWidth, 100);
    this.tvCTABanner.y = this.game.defaultHeight - 100;

    this.tvCTA = this.game.make.text(0, 0, this.game.copy.getCopy('tv_cta'), {
      font: '24px ' + this.game.titleFontStyle,
      fill: '#FFFFFF',
      align: 'center',
      boundsAlignH: 'center',
      boundsAlignV: 'middle',
      wordWrap: true,
      wordWrapWidth: gang.width,
    });
    this.tvCTA.setShadow(0, 4, 'rgba(0,0,0,0.15)', 0);
    this.tvCTA.setTextBounds(0, 0, this.game.defaultWidth, 100);

    this.tvCTABanner.addChild(this.tvCTA);
    this.container.add(this.tvCTABanner);

    // play music
    this.game.sounds.setBackgroundMusic('music_intro', true);
    this.game.scale.onSizeChange.add(this.handleResize, this);
    this.handleResize();
  }

  handlePlayButton() {
    // this.game.sounds.playSpriteSFX('click', { spriteID: 'general_audio' });
    this.game.gameController.triggerStoryIntro();
  }

  handleResize() {
    const btnBoom = this.hud.getButton('boomlogo');
    const btnHelp = this.hud.getButton('howtoplay');
    const spacing = btnHelp.world.x - (btnBoom.world.x + btnBoom.width * btnBoom.scale.x);
  }

  update() {}

  shutdown() {
    this.game.scale.onSizeChange.remove(this.handleResize, this);
    //this.game.sounds.stopBackgroundMusic();

    this.playButton.onInputDown.remove(this.handlePlayButton, this);
    this.playButton.destroy();
    // destroy
    this.container.destroy(true);
    this.hud.destroy(true);

    this.hud = null;
    this.container = null;

    // clear up
    this.container = null;
  }
}



// WEBPACK FOOTER //
// ./js/app/states/Welcome.js